@charset "UTF-8";

/* src/app/shared/contract/contract-item/contract-thema-nego/thema-not-guaranteed-managing-dialog/thema-not-guaranteed-managing-dialog.component.scss */
.container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  margin: 0;
  border-radius: 5px;
  max-height: 750px;
  overflow-y: auto;
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
  margin-bottom: 10px;
}
.bloc-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.inputs-container .input {
  flex-grow: 1;
}
.inputs-container-top {
  align-items: flex-start;
}
.red-title-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: #F03C64;
}
.red-title {
  font: 400 14px FranceTV Brown;
  color: #F03C64;
}
.red-info-container {
  display: flex;
  flex-direction: row;
  gap: 2px;
}
.red-info-container .mat-icon {
  align-self: center;
  width: 15px;
  height: 15px;
  font-size: 14px;
  color: #F03C64;
}
.button-edit {
  justify-content: flex-end;
  display: inline-flex;
}
.saving-content {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 260px;
  width: 100%;
}
.tv-ns-secondary-large-button-on-light-bg {
  width: 150px;
  margin-right: 25px;
}
.tv-ns-validation-large-button {
  width: 150px;
}
.container-chips {
  display: flex;
  gap: 5px;
  align-items: center;
  flex-wrap: wrap;
  max-width: 905px;
}
.block-chip {
  display: flex;
  align-items: center;
  padding: 4px 7px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #6B90B3;
  color: #fff;
}
.block-chip .mat-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.block-chip .material-icons {
  font-size: 16px;
}
.block-chip .text {
  font-size: 12px;
  margin-right: 3px;
}
.condition-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.content-position {
  align-items: center;
  width: 100%;
}
.all-option-button {
  margin-right: 10px;
}
.channel-logo {
  margin-right: 8px;
  width: 14px;
  height: auto;
}
.unit-label {
  padding: 0 10px 0 10px;
}
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.container-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
  padding: 10px 0;
}
.bloc-container-row-60-percent {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  gap: 20px;
}
.bloc-container-row-60-percent .bloc-container-channel {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.bloc-container-row-60-percent .bloc-container-share {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.bloc-container-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  background-color: #FFF;
  border-radius: 5px;
}
.bloc-container-row .bloc-container-pack {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
}
.custom-channel-row-adjustment {
  padding: 5px 10px;
  margin: 0 10px 10px 10px;
}
.channel-logo {
  height: 16px;
}
.channel-name {
  font: 400 14px FranceTV Brown;
  color: #6B90B3;
}
.inputs-channels-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
}
/*# sourceMappingURL=thema-not-guaranteed-managing-dialog.component.css.map */
